import { useEffect, useState } from "react";
import { Drawer, Layout, Popover, Select, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { LockOutlined, LogoutOutlined, SettingTwoTone } from "@ant-design/icons";
import { toggleCollapsedSideNav } from "../../appRedux/actions";
import UserInfo from "../../components/UserInfo";
import Auxiliary from "util/Auxiliary";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  TAB_SIZE,
} from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";
import { userSignOut } from "../../appRedux/actions/Auth";
import LogOut from "../../components/LogOut";
import ChangePassword from "../../components/ChangePassword";
import SoundOff from "../../../src/assets/image/sound-off.png";
import SoundOn from "../../../src/assets/image/sound-on.png";
import tzData from "moment-timezone/data/meta/latest.json";

const { Header } = Layout;

const Topbar = (props) => {
  const dispatch = useDispatch();
  const { navStyle } = useSelector(({ settings }) => settings);
  const navCollapsed = useSelector(({ common }) => common.navCollapsed);
  const width = useSelector(({ common }) => common.width);
  const [visibleModal, setVisibleModal] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);
  const [soundOn, setSoundOn] = useState(localStorage.getItem("sound"));
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [countryTimezoneList, setCountryTimezoneList] = useState([]);

  const onLogOut = () => {
    setConfirmModel(false);
    localStorage.removeItem("websiteID");
    localStorage.removeItem("user");
    localStorage.removeItem("name");
    localStorage.removeItem("type");
    localStorage.removeItem("id");
    localStorage.removeItem("agent_selected_url");
    localStorage.removeItem("user_token");
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    localStorage.removeItem("sortByA");
    dispatch(userSignOut());
    window.location.reload();
  };

  const updateSound = (value, e) => {
    e.preventDefault();
    console.log(value, "value---->>>>>");
    setSoundOn(!value);
    localStorage.setItem("sound", !value);
    // localStorage.setItem("sound", value.toString());
    // dispatch(fetchSoundOnOff(value));
    if (props.onSoundUpdate) {
      props.onSoundUpdate(value);
    }
  };

  const onChangeTimeZone = (e) => {
    localStorage.setItem("timezone", e);
    window.location.reload();
  }

  const getAllCountryTimezone = async () => {
    let cList = [];
    Object.values(tzData.countries).forEach(item => {
      if (!cList.some(existingItem => existingItem.value === item.zones[0])) {
        cList.push({
          key: item.abbr,
          label: item.name,
          value: item.zones[0]
        });
      }
    });

    setCountryTimezoneList(cList);
  }

  useEffect(() => {
    if(!localStorage.getItem("timezone")) localStorage.setItem("timezone", "Asia/Kolkata");
    getAllCountryTimezone();
  }, []);

  return (
    <Header>
      {navStyle === NAV_STYLE_DRAWER ||
      ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) &&
        width < TAB_SIZE) ? (
        <div className="gx-linebar gx-mr-3">
          <i
            className="gx-icon-btn icon icon-menu"
            onClick={() => {
              dispatch(toggleCollapsedSideNav(!navCollapsed));
            }}
          />
        </div>
      ) : null}
      <Link to="/" className="gx-d-block gx-d-lg-none gx-pointer">
        <img alt="" src={"/assets/images/w-logo.png"} />
      </Link>

      <ul className="gx-header-notifications gx-ml-auto">
        {/* Change Password and Logout Button */}
        {width <= TAB_SIZE ? null : (
          <div
            // className="gx-sidebar-content"
            // style={{ marginLeft: "0px", padding: "10px" }}
            style={{ display: "flex" }}
          >
            {countryTimezoneList && countryTimezoneList?.length > 0 && <Tooltip title={`Timezone (${countryTimezoneList?.find(item => item.value === localStorage.getItem("timezone")).label})`}>
              <SettingTwoTone style={{ fontSize: 25, margin: 10 }} onClick={() => setIsDrawerOpen(true)} />
            </Tooltip>}
            <a
              onClick={(e) => {
                updateSound(soundOn, e);
              }}
              style={{ margin: "10px" }}
            >
              {localStorage.getItem("sound") &&
              soundOn.toString() === "true" ? (
                <Tooltip title="Sound On">
                  <img src={SoundOn} alt="Sound On" width={26} />
                </Tooltip>
              ) : (
                <Tooltip title="Sound Off">
                  <img src={SoundOff} alt="Sound Off" width={26} />
                </Tooltip>
              )}
            </a>
            <a
              onClick={() => {
                setVisibleModal(true);
              }}
              style={{ margin: "10px" }}
            >
              <LockOutlined style={{ fontSize: "25px" }} />
            </a>
            <a
              onClick={() => {
                setConfirmModel(true);
              }}
              style={{ margin: "10px" }}
            >
              <LogoutOutlined style={{ fontSize: "25px" }} />
            </a>
          </div>
        )}
        {/* <li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none">
          <Popover
            overlayClassName="gx-popover-horizantal"
            placement="bottomRight"
            trigger="click"
          >
            <span className="gx-pointer gx-d-block">
              <i className="icon icon-search-new" />
            </span>
          </Popover>
        </li>
        {width >= TAB_SIZE ? null : (
          <Auxiliary>
            <li className="gx-notify">
              <Popover
                overlayClassName="gx-popover-horizantal"
                placement="bottomRight"
                trigger="click"
              >
                <span className="gx-pointer gx-d-block">
                  <i className="icon icon-notification" />
                </span>
              </Popover>
            </li>

            <li className="gx-msg">
              <Popover
                overlayClassName="gx-popover-horizantal"
                placement="bottomRight"
                trigger="click"
              >
                <span className="gx-pointer gx-status-pos gx-d-block">
                  <i className="icon icon-chat-new" />
                  <span className="gx-status gx-status-rtl gx-small gx-orange" />
                </span>
              </Popover>
            </li>
          </Auxiliary>
        )}
        <li className="gx-language"></li>
        {width >= TAB_SIZE ? null : (
          <Auxiliary>
            <li className="gx-user-nav">
              <UserInfo />
            </li>
          </Auxiliary>
        )} */}
      </ul>
      <LogOut
        visibleModel={confirmModel}
        handleSubmit={onLogOut}
        handleCancel={() => {
          setConfirmModel(false);
        }}
      />
      <ChangePassword
        visibleModal={visibleModal}
        setVisibleModal={setVisibleModal}
      />
      <Drawer title="Timezone" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} style={{ marginRight: "-5%" }} >
        <Select
          showSearch
          placeholder="Select Country"
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          options={countryTimezoneList}
          defaultValue={localStorage.getItem("timezone")}
          onChange={onChangeTimeZone}
          style={{
            margin: 20,
            width: "60%"
          }}
        />
      </Drawer>
    </Header>
  );
};

export default Topbar;
